import React from "react";
import { Container, Icon } from "../components";
import { MultiPassAccess } from "./api";
import { Text } from "./text";
import { Spacer } from "./spacer";
import { displayBookingDate } from "./multipass_access";

interface MultiPassCardProps {
  multiPassAccess: MultiPassAccess;
  readOnly?: boolean;
}

export function MultiPassCard(props: MultiPassCardProps) {
  const { multiPassAccess, readOnly } = props;

  return (
    <div className="multi-pass-card-root">
      <img
        alt="Mindpass Multi"
        src={multiPassAccess.space.thumbnailImage}
        className="multi-pass-card-thumbnail"
      />
      <Spacer size={10} direction="horizontal" />
      <div className="multi-pass-card-text">
        <Text weight="bold">{multiPassAccess.name}</Text>

        <div className="multi-pass-card-location">
          <Icon size={16} name="map-pin" />
          <Spacer size={4} direction="horizontal" />
          <Container flex={1}>
            <Text>
              {multiPassAccess.location.streetAddress},{" "}
              {multiPassAccess.location.city}
            </Text>
          </Container>
        </div>
        {multiPassAccess.expired ? (
          <div>
            <Text color="error" weight="bold" size="xs">
              Expired{" "}
              {displayBookingDate(
                multiPassAccess.expirationDate,
                undefined,
                "short"
              )}
            </Text>
          </div>
        ) : (
          <div className="multi-pass-card-bookings">
            <div className="multi-pass-card-booking">
              <Text size="sm">{multiPassAccess.bookingsUsedCount}</Text>
              <Text color="muted" size="xs">
                booking
              </Text>
            </div>
            <div className="multi-pass-card-booking">
              <Text size="sm">{multiPassAccess.bookingsUnusedCount}</Text>
              <Text color="muted" size="xs">
                available
              </Text>
            </div>
          </div>
        )}
      </div>
      {!readOnly && (
        <div className="multi-pass-card-icon-wrapper">
          <Icon size={18} color="#A7ABB2" name="chevron-right" />
        </div>
      )}
    </div>
  );
}
